module.exports = __webpack_public_path__ + "img/act_pro_im9s_03.9fc06b08.png";